import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(Vuetify, {
  theme: {
    primary:   '#8bc34a',
    secondary: '#3f51b5',
    accent:    '#e91e63',
    error:     '#f44336',
    warning:   '#ffc107',
    info:      '#2196f3',
    success:   '#00bcd4'
  }
})

new Vue({
  render: h => h(App),
}).$mount('#app')
